import {contactValueMaxLength, contactValueMinLength} from 'api/gen/ContactValue';
import {t} from 'app/translations';
import {EskotValidator} from 'utils/eskot-validator';
import {Errors} from 'utils/validator';

import {UserContactFormValues} from '../../types/user-contact-form-values';

const te = t('userDetail');

/**
 * Validates the contact modal fields before the form is submitted.
 *
 * @param values Contact form values to validate.
 * @returns Validation errors for the current contact form state.
 *
 * @example
 * validate(contactValues);
 */
export const validate =
    (values: UserContactFormValues): Errors<UserContactFormValues> => {
        const validator = new EskotValidator(values);
        const contactValueLabel = te('contactValue');

        validator.nonEmpty('contactType', te('contactType'));
        validator.nonEmpty('value', contactValueLabel);
        validator.maxStringLength('value', contactValueMaxLength, contactValueLabel);
        validator.minStringLength('value', contactValueMinLength, contactValueLabel);

        if (values.contactType === 'E_MAIL') {
            validator.email('value', contactValueLabel);
        }

        return validator.generateErrorsObject();
    };
